import { environment } from 'src/environments/environment';

export class BaseApiService {
	protected readonly apiBaseUrl;

	constructor() {
		this.apiBaseUrl = environment.apiBaseUrl;
	}
}
